<template>
  <div class="actionPlan">
    <div class="list">
      <ul class="listData" v-show="dataList.length>0">
        <li v-for="(item,key) in dataList" :key="key">
          <ul class="top">
            <li>
              <div class="div1">
                学期
              </div>
              <div class="div2">
                {{item.gradeName}}
              </div>
            </li>
            <li>
              <div class="div1">
                考试
              </div>
              <div class="div2">
                {{item.nameName}}
              </div>
            </li>
            <li>
              <div class="div1">
                总分
              </div>
              <div class="div2">
                {{item.totalScore}}
              </div>
            </li>
            <li>
              <div class="div1">
                年级总排名
              </div>
              <div class="div2">
                {{item.totalRank}}
              </div>
            </li>
            <li>
              <div class="div1">操作</div>
              <div class="div2">
                <span style="margin-right: 20px" @click="gradeDetail(item,key)">查看详情</span>
                <span :style='{background:key>0||(key==0&&item.gradeName!=name)?"#ccc":(item.list&&item.list.length==4?"#ccc":"")}' @click="addActionPlan(item,key)">添加行动计划</span>
              </div>
            </li>
          </ul>
          <div class="bottom" v-if="item.list&&item.list.length>0">
            <table>
              <tr>
                <th>序号</th>
                <th>行动计划</th>
                <th>规划时间</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
              <tr v-for="(it,i) in item.list||[]">
                <td>{{i+1}}</td>
                <td style="cursor: pointer" @click="$router.push(
                    {path:'/consultant/minestudent/main/implement/actionplan/show',
                     query:{actionPlanId:it.id
                     }})"
                     class="hoverActionPlan">{{it.actionPlanName}}行动计划</td>
                <td>{{it.interviewTime}}</td>
                <td :style="{color:it.interviewRecordIdAssess?'#Ed7620':''}">{{it.interviewRecordIdAssess?'已评估':'待评估'}}</td>
                <td style="cursor: pointer;color:#3d90f6" @click="jumpAssement(it,item)">{{it.interviewRecordIdAssess?'查看':'评估'}}</td>
              </tr>
            </table>
          </div>
        </li>
      </ul>
      <Pages :page-data="options" :change="getAchievementList"></Pages>
      <div v-show="dataList.length==0" class="list">
        <Add  name="暂无数据!" :path="{path:'/consultant/minestudent/main/studentMessage/grade/add',query:$route.query}"></Add>
      </div>
    </div>
  </div>
</template>
<script>
  import Pages from '@/components/assembly/Pagination';
  import Add from '@/components/xueyezixun/Add.vue'
  export default {
    name: 'list',
    components:{Add,Pages},
    data() {
      return {
        dataList: [],
        options: {
          current: 1,
          total: 0,
          pageSize: 5,
          totalPage: 1,
        },
        name: ''
      }
    },
    methods: {
      getAchievementList(pageNumber, pageSize) {
        this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.grade.getAchievementList, {
          studentId: sessionStorage.getItem("myStudentStudentId"),
          pageNumber: pageNumber || this.options.current,
          pageSize: pageSize || this.options.pageSize
        }, {
          headers: {
            token: window.sessionStorage.getItem('ymtxToken')
          }
        }).then((res) => {
          if (res.data.code == 2000) {
            let list = res.data.data.list;
            this.dataList=list
            this.options.total=res.data.data.page.count;
            this.options.totalPage=res.data.data.page.totalPage;
            this.$nextTick(()=>{
              let _this=this
              list.forEach((item,key)=>{
                _this.getList(item.id,key)
              })
            })
          } else {

          }
        })
        this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.chaifenNow, {
          studentId:sessionStorage.getItem("myStudentStudentId"),
        }, {
          headers: {
            token: window.sessionStorage.getItem('ymtxToken')
          }
        }).then((res) => {
          if (res.data.code == 2000) {
            this.name=res.data.data.name;
            console.log(this.name)
          }else{

          }
        })
      },
      getList(id,key){
        this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.list, {
          id:id
        }, {
          headers: {
            token: window.sessionStorage.getItem('ymtxToken')
          }
        }).then((res) => {
          if (res.data.code == 2000) {
            // this.dataList[key].list=res.data.data
            this.$set(this.dataList[key],'list',res.data.data)
          }else{

          }
        })
      },
      gradeDetail(item,key){
        let length=0
        let str='';
        if(item.list.length){
          item.list.forEach((item,key)=>{
            str+=item.actionPlan
          })
        }else{
          str='0'
        }
        length=item.list.length;
        if(key!=0||(key==0&&item.gradeName!=this.name)){
          length=4
        }
        this.$router.push({path:'/consultant/minestudent/main/implement/actionplan/gradeDetail',query:{...this.$route.query,gradeDetailId:item.id,length:length,array:str}})
      },
      addActionPlan(item,key){
        if(key==0){
          if(item.gradeName!=this.name){
            return;
          }
          if(item.list.length==4){
            return;
          }
          let str='';
          item.list.forEach((item,key)=>{
            str+=item.actionPlan
          })
          str=str?str:0
          this.$router.push({path:'/consultant/minestudent/main/implement/actionplan/add',query:{...this.$route.query,gradeDetailId:item.id,array:str}})
        }
      },
      jumpAssement(it,item){
        if(it.interviewRecordIdAssess){
          this.$router.push({path:'/consultant/minestudent/main/implement/actionplan/assessmentShow',query:{...this.$route.query,actionPlanId:it.id,gradeDetailId:item.id}})
        }else{
          this.$router.push({path:'/consultant/minestudent/main/implement/actionplan/assessmentAdd',query:{...this.$route.query,actionPlanId:it.id,gradeDetailId:item.id}})
        }
      }
    },
    mounted() {
      this.getAchievementList()
    }
  }
</script>
<style scoped lang="less">
  @import "./css/index.less";
</style>